import React, { memo, useMemo } from 'react';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import FormGenerator from '../FormGenerator';
import FormGeneratorRadioGroup from '../FormGeneratorRadioGroup';

import { getAdditionalContentStyles } from './FormGeneratorExtendableRadioGroup.styles';

const defaultObject = {};

const FormGeneratorExtendableRadioGroup = ({
  additionalContentBySelectedOption = defaultObject,
  additionalContent = null,
  formGeneratorProps = defaultObject,
  ...props
}) => {
  const { value } = props;
  const additionalContentConfig = additionalContentBySelectedOption[value];

  const additionalFormGeneratorContent = useMemo(() => {
    if (!additionalContentConfig) {
      return;
    }

    return (
      <Box
        className="additional-content"
        sx={getAdditionalContentStyles(formGeneratorProps.numberOfColumns)}
      >
        <FormGenerator config={additionalContentConfig} {...formGeneratorProps} />
        {additionalContent}
      </Box>
    );
  }, [additionalContentConfig, formGeneratorProps, additionalContent]);

  return (
    <>
      <FormGeneratorRadioGroup {...props} />
      {additionalFormGeneratorContent}
    </>
  );
};

FormGeneratorExtendableRadioGroup.propTypes = {
  ...FormGeneratorRadioGroup.propTypes,
  additionalContentBySelectedOption: PropTypes.object,
  formGeneratorProps: PropTypes.object,
  additionalContent: PropTypes.element,
};

export default memo(FormGeneratorExtendableRadioGroup);
